import ReactTooltip from 'react-tooltip'
import { WarningCircle } from '@phosphor-icons/react'
import PropTypes from 'prop-types'

const Tooltip = ({ tooltip, name, place = 'right' }) => {
  return (
    <span className="event-form-tooltip" data-tip data-for={`${name}-triggerTip`}>
      <WarningCircle className="event-form-tooltip__icon" />
      <ReactTooltip
        className="tooltip"
        id={`${name}-triggerTip`}
        multiline
        place={place}
        effect="solid"
      >
        {tooltip}
      </ReactTooltip>
    </span>
  )
}

Tooltip.propTypes = {
  tooltip: PropTypes.node,
  name: PropTypes.string,
}

export default Tooltip
